<template>
  <div>
    <div class="wrapper">
    <!-- <div :class="'wrapper ' + (show ? '' : 'sidebar_minimize') "> -->
      <!---------------------------------------------------------- top -->
      <div class="main-header">
        <!-- Logo Header -->
        <div class="logo-header" data-background-color="blue">
          <a href="javascript:void(0)" @click="refresh_active('/welcome')" class="logo">
            <img :src="custom.image || 'img/F1-uwss.png'" alt="navbar brand" class="navbar-brand" width="150">
          </a>

          <button class="navbar-toggler sidenav-toggler ml-auto" type="button" data-toggle="collapse" data-target="collapse" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon">
                  <i class="icon-menu icon_menu_01"></i>
              </span>
          </button>
          <button class="topbar-toggler more">
              <i class="icon-options-vertical icon_menu_01"></i>
          </button>
          <div class="nav-toggle">
              <button class="btn btn-toggle toggle-sidebar toggled">
                  <i class="icon-menu icon_menu_01"></i>
              </button>
          </div>
        </div>
        <!-- End Logo Header -->

        <!-- Navbar Header -->
        <nav class="navbar navbar-header navbar-expand-lg" data-background-color="blue2">
          <div class="container-fluid">
            <div class="collapse" id="search-nav">
              <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
                <li class="nav-item" data-name="/webcastle/dashboard"
                  v-if="auth && auth.license && auth.license.WEBCastle && auth.license.WEBCastle.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/webcastle/dashboard')">
                    <div class="p-1"><i class="fas fa-paste top_icon"></i></div>
                    <div class="nav_link_tit">WEBCastle</div>
                    <div class="nav_link_sub font_10">(Webアプリケーションファイアウォール)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="/wsfinder/dashboard"
                  v-if="auth && auth.license && auth.license.WSFinder && auth.license.WSFinder.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/wsfinder/dashboard')">
                    <div class="p-1"><i class="fas fa-table top_icon"></i></div>
                    <div class="nav_link_tit">WSFinder</div>
                    <div class="nav_link_sub font_10">(WebShell検出システム)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="/wmds/dashboard"
                  v-if="auth && auth.license && auth.license.WMDS && auth.license.WMDS.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/wmds/dashboard')">
                    <div class="p-1"><i class="fas fa-list-alt top_icon"></i></div>
                    <div class="nav_link_tit">WMDS</div>
                    <div class="nav_link_sub font_10">(Webマルウェア検出システム)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="/integrity/dashboard"
                  v-if="auth && auth.license && auth.license.WFDetect && auth.license.WFDetect.use == true && allow_solution_dashboard"
                >
                  <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/integrity/dashboard')">
                    <div class="p-1"><i class="fas fa-th-list top_icon"></i></div>
                    <div class="nav_link_tit">WFDetector</div>
                    <div class="nav_link_sub font_10">(Web偽造検知システム)</div>
                  </a>
                </li>
                <li class="nav-item" data-name="">
                  <a class="nav-link" href="javascript:void(0)" @click="manual()">
                    <div class="nav_link_tit">マニュアル</div>
                  </a>
                </li>
              </ul>
            </div>
            <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
              <li class="nav-item dropdown hidden-caret">
                <Language />
              </li>
              <li class="nav-item hidden-caret" data-name="/profile">
                <a class="nav-link-toggle" href="javascript:void(0)" @click="refresh_active('/profile')">
                  <i class="fas fa-user-alt mr-1 user_i"></i>
                  <span class="user" style="font-size:13px !important;">
                    {{auth.profile.username}}
                  </span>
                </a>
              </li>
              <li class="nav-item hidden-caret" data-name="/welcome">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/welcome')">
                  <i class="fas fa-bell nav_link_I"></i>
                  <span class="notification" v-if="auth.UWSS_status == 2" style="background-color: red;">危険</span>
                  <span class="notification" v-else-if="auth.UWSS_status == 1" style="background-color: #ffc108;">注意</span>
                  <span class="notification" v-else style="background-color: #4ebd75 ;">安全</span>
                </a>
              </li>
              <li class="nav-item hidden-caret">
                <a class="nav-link" href="javascript:void(0)" @click="toggle">
                  <i class="fas fa-history nav_link_I"></i>
                  <span class="notification" :class="{ 'bg-secondary': pause }">{{stale}}</span>
                </a>
              </li>
              <li class="nav-item hidden-caret">
                <button class="btn btn-search" @click="logout()">
                  <i class="fas fa-sign-out-alt mr-1"></i>
                  <span>ログアウト</span>
                </button>
              </li>
            </ul>
          </div>
        </nav>
        <!-- End Navbar -->
      </div>
      <!---------------------------------------------------------- top-->
      <!---------------------------------------------------------- sub-->
      <!-- Sidebar -->
      <div class="sidebar sidebar-style-2">
        <div class="sidebar-wrapper scrollbar scrollbar-inner scroll-scrolly_visible">
          <div class="sidebar-content">
            <ul class="nav nav-primary">
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  管理
                </h4>
              </li>
              <li class="nav-item" data-name="/group">
                <a href="javascript:void(0)" @click="refresh_active('/group')">
                  <i class="fas fa-users"></i>
                  <p>グループ情報</p>
                </a>
              </li>
              <li class="nav-item" data-name="/user">
                <a href="javascript:void(0)" @click="refresh_active('/user')">
                  <i class="fas fa-user"></i>
                  <p>ユーザー情報</p>
                </a>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  SUMMARY
                </h4>
              </li>
              <li class="nav-item" data-name="/downloads">
                <a href="javascript:void(0)" @click="refresh_active('/downloads')">
                  <i class="fas fa-download"></i>
                  <p>ダウンロード</p>
                </a>
              </li>
              <li class="nav-item" data-name="/welcome">
                <a href="javascript:void(0)" @click="refresh_active('/welcome')">
                  <i class="fas fa-chart-line"></i>
                  <p>ダッシュボード</p>
                </a>
              </li>
              <li class="nav-item" data-name="/report">
                <a href="javascript:void(0)" @click="refresh_active('/report')">
                  <i class="fas fa-clipboard"></i>
                  <p>レポート</p>
                </a>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff; ">
                  <span class="pr-1">
                  </span>
                  セキュリティ設定
                </h4>
              </li>
              <li class="nav-item" data-name="/webcastle">
                <a data-toggle="collapse" href="#WEBCastle">
                  <i class="fas fa-paste"></i>
                  <p>WEBCastle</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WEBCastle">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/webcastle/agent')">
                        <span class="sub-item">Webサーバ</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/webcastle/log')">
                        <span class="sub-item">ログ</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" data-name="/wsfinder" v-if="auth && auth.license && auth.license.WSFinder && auth.license.WSFinder.use == true">
                <a data-toggle="collapse" href="#WSFinder">
                  <i class="fas fa-table"></i>
                  <p>WSFinder</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WSFinder">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/agent')">
                        <span class="sub-item">エージェント</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/detect')">
                        <span class="sub-item">検出</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/result')">
                        <span class="sub-item">結果</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/hash')">
                        <span class="sub-item">例外</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/report')">
                        <span class="sub-item">分析依頼</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wsfinder/pattern')">
                        <span class="sub-item">パターン</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" data-name="/wmds" v-if="auth && auth.license && auth.license.WMDS && auth.license.WMDS.use == true">
                <a data-toggle="collapse" href="#WMDS">
                  <i class="fas fa-list-alt"></i>
                  <p>WMDS</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WMDS">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/site')">
                        <span class="sub-item">サイトリスト</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/pattern')">
                        <span class="sub-item">パターン</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/detect')">
                        <span class="sub-item">検出</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/result')">
                        <span class="sub-item">結果</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/schedule')">
                        <span class="sub-item">スケジュール</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/wmds/policy')">
                        <span class="sub-item">ポリシー</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" data-name="/integrity" v-if="auth && auth.license && auth.license.WFDetect && auth.license.WFDetect.use == true">
                <a data-toggle="collapse" href="#WFDetector">
                  <i class="fas fa-th-list"></i>
                  <p>WFDetector</p>
                  <span class="caret"></span>
                </a>
                <div class="collapse" id="WFDetector">
                  <ul class="nav nav-collapse">
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/main')">
                        <span class="sub-item">メイン</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/wsfinder')">
                        <span class="sub-item">WSFinder</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/wmds')">
                        <span class="sub-item">WMDS</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="refresh_active('/integrity/detect')">
                        <span class="sub-item">検出</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <!-- <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                  </span>
                  Support
                </h4>
              </li>
              <li class="nav-item" data-name="/boards/qna">
                <a href="javascript:void(0)" @click="support()">
                  <i class="fas fa-question-circle"></i>
                  <p>Technical support</p>
                </a>
              </li> -->
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                  </span>
                  Boards
                </h4>
              </li>
              <li class="nav-item" data-name="/boards/qna">
                <a href="javascript:void(0)" @click="refresh_active('/boards/qna')">
                  <i class="fas fa-question-circle"></i>
                  <p>Q &amp; A</p>
                </a>
              </li>
              <li class="nav-item" data-name="/boards/faq">
                <a href="javascript:void(0)" @click="refresh_active('/boards/faq')">
                  <i class="fas fa-filter"></i>
                  <p>FAQ</p>
                </a>
              </li>
              <li class="nav-item" data-name="/boards/notice">
                <a href="javascript:void(0)" @click="refresh_active('/boards/notice')">
                  <i class="fas fa-bell"></i>
                  <p>お知らせ</p>
                </a>
              </li>
              <li class="nav-section">
                <span class="sidebar-mini-icon">
                  <i class="fa fa-ellipsis-h"></i>
                </span>
                <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                  <span class="pr-1">
                    <!-- <i class="icon-tag"></i> -->
                  </span>
                  MY INFO
                </h4>
              </li>
              <li class="nav-item" data-name="/profile">
                <a href="javascript:void(0)" @click="refresh_active('/profile')">
                  <i class="far fa-address-card"></i>
                  <p>プロフィール</p>
                </a>
              </li>
              <li class="nav-item" data-name="">
                <a href="javascript:void(0)" @click="logout()">
                  <i class="fas fa-sign-out-alt"></i>
                  <p>ログアウト</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!---------------------------------------------------------- sub-->
      <div class="main-panel">
        <div class="content">
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
        <b-modal title="マニュアル通知"  class="modal-danger" v-model="alert" ok-variant="primary" ok-only>
          現在、マニュアルは英語版と韓国語版のみをサポートしています。
          <br>
          できる限り早く日本語マニュアルをご用意させていただきます。
        </b-modal>
        <!---------------------------------------------------------- footer-->
        <footer class="footer">
          <div class="container-fluid text-center">
            <div v-if="!is_custom" style="margin: 0 auto !important;">
              <a href="http://www.f1security.co.kr">F1Security Inc.</a>
              <span>234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea</span>
              <span> Copyright {{ get_year() }} {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}} All right reserved. {{ custom.address ? custom.address : '' }} </span>
            </div>
            <div v-else style="margin: 0 auto !important;">
              <!-- 今後カスタム情報が追加される可能性があります -->
              <span> Copyright {{ get_year() }} {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}} All right reserved. {{ custom.address ? custom.address : '' }} </span>
            </div>
          </div>
        </footer>
        <!---------------------------------------------------------- footer-->
      </div>
    </div>
  </div>
</template>


<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
